import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const [isChecking, setIsChecking] = useState(true);

  // 1. Get role from Redux or LocalStorage
  const reduxRole = useSelector((state) => state.auth.role);
  const localStorageRole = localStorage.getItem("userRole");

  useEffect(() => {
    // Simple check to ensure we've attempted to read storage
    setIsChecking(false);
  }, []);

  // 2. Helper to extract the actual role string
  const extractRole = (roleInput) => {
    if (!roleInput) return null;

    let parsed = roleInput;

    // A. Try to parse JSON if it's a string looking like JSON
    if (typeof roleInput === "string") {
      try {
        parsed = JSON.parse(roleInput);
      } catch (e) {
        // If it fails, it's just a raw string (e.g. "CUSTOMER")
        parsed = roleInput;
      }
    }

    // B. Handle Spring Security style: [{ authority: "CUSTOMER" }]
    if (Array.isArray(parsed) && parsed.length > 0) {
      if (parsed[0].authority) {
        return parsed[0].authority;
      }
      return parsed[0]; // Handle ["CUSTOMER"]
    }

    // C. Handle Simple String
    if (typeof parsed === "string") {
      // Remove quotes if they persist
      return parsed.replace(/^"|"$/g, "");
    }

    // D. Handle Object: { authority: "CUSTOMER" }
    if (typeof parsed === "object" && parsed !== null && parsed.authority) {
      return parsed.authority;
    }

    return null;
  };

  // 3. Determine the final role
  const currentRole = extractRole(reduxRole) || extractRole(localStorageRole);

  if (isChecking) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
      >
        Loading...
      </div>
    );
  }

  // 4. Authorization Logic
  if (allowedRoles && Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    // If no role found at all, kick them out
    if (!currentRole) {
      console.warn(
        "ProtectedRoute: No role found. Redirecting to unauthorized."
      );
      // Option: Redirect to login if absolutely no identity found
      return <Navigate to="/login" />;
    }

    // If role doesn't match allowed roles
    if (!allowedRoles.includes(currentRole)) {
      console.warn(
        `ProtectedRoute: Role ${currentRole} not authorized. Expected: ${allowedRoles}`
      );
      return <Navigate to="/unAuthorized" />;
    }
  }

  return children;
};

export default ProtectedRoute;
